import { AxiosApi, ApiResult } from './axiosApi';
import { MaintenanceModeDto, MaintenanceModeStatusDto } from '../dtos/site';

export class MaintenanceModeApi extends AxiosApi<MaintenanceModeDto> {
    constructor(baseUri: string, logout?: () => void, enqueueSnackbar?: any) {
        super(baseUri, 'sites', logout, enqueueSnackbar);
    }

    public getStatus = (siteId: number) =>
        this.genericRequest({
            method: 'GET',
            extraPath: `${siteId}/maintenance-mode`,
        }) as Promise<ApiResult<MaintenanceModeStatusDto>>;

    public enable = (siteId: number, dto: MaintenanceModeDto) =>
        this.genericRequest({
            method: 'POST',
            extraPath: `${siteId}/maintenance-mode`,
            data: dto,
        }) as Promise<ApiResult<MaintenanceModeDto>>;

    public extend = (siteId: number, newEndTime: string) =>
        this.genericRequest({
            method: 'PUT',
            extraPath: `${siteId}/maintenance-mode/extend`,
            data: { newEndTime },
        }) as Promise<ApiResult<void>>;

    public disable = (siteId: number) =>
        this.genericRequest({
            method: 'DELETE',
            extraPath: `${siteId}/maintenance-mode`,
        }) as Promise<ApiResult<void>>;

    public getActiveForDealer = (dealerId: number) =>
        this.genericRequest({
            method: 'GET',
            overridePath: `dealers/${dealerId}/maintenance-modes/active`,
        }) as Promise<ApiResult<MaintenanceModeDto[]>>;

    public getActiveForOrg = (orgId: number) =>
        this.genericRequest({
            method: 'GET',
            overridePath: `organizations/${orgId}/maintenance-modes/active`,
        }) as Promise<ApiResult<MaintenanceModeDto[]>>;

    public getActiveAll = () =>
        this.genericRequest({
            method: 'GET',
            overridePath: `maintenance-modes/active`,
        }) as Promise<ApiResult<MaintenanceModeDto[]>>;
}
